import APIClient from "./apiClient";

export default new APIClient("/contactInfo")